/** Plaid Link onExit error shape (react-plaid-link / Link). */
export interface PlaidLinkExitError {
  error_code?: string;
  error_type?: string;
  error_message?: string;
  display_message?: string | null;
}

const INSTITUTION_ERROR_TYPE = 'INSTITUTION_ERROR';

const INSTITUTION_ERROR_CODES = new Set([
  'INSTITUTION_NOT_RESPONDING',
  'INSTITUTION_DOWN',
  'INSTITUTION_NOT_AVAILABLE',
  'INSTITUTION_NO_LONGER_SUPPORTED',
  'INSTITUTION_REGISTRATION_FAILED',
]);

export function isPlaidInstitutionConnectionError(error: PlaidLinkExitError | null | undefined): boolean {
  if (!error) return false;
  if (error.error_type === INSTITUTION_ERROR_TYPE) return true;
  return Boolean(error.error_code && INSTITUTION_ERROR_CODES.has(error.error_code));
}

const INSTITUTION_CONNECTION_HELP =
  'Plaid could not connect to your bank right now. This is a problem between Plaid and your financial institution, not something wrong with your Amber Peak application. Close the bank window, stay on this page, and choose Send a blank agreement instead below—you can fill in your bank details manually on the DocuSign form. You can also try connecting your bank again later.';

const QUIET_EXIT_CODES = new Set(['USER_EXIT', 'USER_CANCELLED']);

export function messageForPlaidLinkExit(error: PlaidLinkExitError | null | undefined): string | null {
  if (!error) return null;
  if (error.error_code && QUIET_EXIT_CODES.has(error.error_code)) {
    return null;
  }
  if (isPlaidInstitutionConnectionError(error)) {
    return INSTITUTION_CONNECTION_HELP;
  }
  if (error.display_message?.trim()) {
    return error.display_message.trim();
  }
  if (error.error_code === 'INVALID_CREDENTIALS') {
    return 'Your bank login was not accepted. Check your credentials and try again, or send a blank agreement instead and fill in your details on the form.';
  }
  return 'Bank connection did not finish. Try again, or send a blank agreement instead below.';
}
